/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

export type ShipmentsTasksListTaskType = typeof ShipmentsTasksListTaskType[keyof typeof ShipmentsTasksListTaskType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsTasksListTaskType = {
  Sub_Task: 'Sub Task',
  Task: 'Task',
} as const;
